<template>
  <div class="wrap">
    <div
    v-if="!isMobile.isMobile"
      style="
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0;
        margin: 0;
        height: 350px;
        background-image: linear-gradient(135deg, #1bdf89, #1f9077);
      "
    >
      <span class="iconfont icon-fanhui back" @click="goBack">
        <md-tooltip md-direction="top" v-if="!isMobile.isMobile">返回</md-tooltip>
      </span>

    </div>
    <div
      style="
        position: absolute;
        top: 20px;
        right: 20px;
        margin: 0;
      "
       v-if="getRoute() == 'courseEdit'"
    >
      <v-btn   size="x-small" color="rgb(76, 175, 80)" @click.stop="submit"  style="color: #fff;"> 提交 </v-btn>
    </div>
    
    <article class="articleStyle" :style="{transform:isMobile.isMobile?'translateY(0px)':'translateY(100px)'}">
      <div :style="{padding:isMobile.isMobile?'10px':'20px',backgroundColor: '#fff', borderRadius: '4px'}">
        <div class="wrapheader">
          <banner :routeData="routeData" :key="1"></banner>
          <bannerRight :routeData="routeData" :key="2" :getMesageTitolValue="getMesageTitolValue"> </bannerRight>
        </div>
        <div class="tabsWraps">
          <courseDetail :routeData="routeData" @getMesageTitol="getMesageTitol"></courseDetail>
          <otherCourse :routeData="routeData" @submit="submit"></otherCourse>
        </div>
       
      </div>
    </article>
  </div>
</template>
<script>
import { getdetailList, queryCourseThree, resetSimulation } from '@/api/simulation';
import banner from '../../Dashboard/SimClassComponents/banner.vue';
import otherCourse from '../../Dashboard/SimClassComponents/otherCourse.vue';
import bannerRight from '../../Dashboard/SimClassComponents/bannerRight.vue';
import { mapGetters } from 'vuex';
import 'video.js/dist/video-js.css';
import { Modal } from '../../../components/index';
import moment from 'moment';
import { openUriWithTimeoutHack } from './monitoringApp.js';
import courseDetail from '../SimClassComponents/courseDetailWrap.vue';
import { getossUploadToken } from '@/api/user';
import Oss from 'ali-oss';
export default {
  components: {
    Modal,
    courseDetail,
    banner,
    bannerRight,
    otherCourse,
  },
  watch: {
    routeData: {
      handler(news) {
        if (news) {
          // this.bannerImg = news.bannerImg
          // console.log(news.bannerImg)
          if (news.bannerImg.length <= 0) {
            let obj = {
              id: this.guid(),
              url: this.routeData.cover,
              type: 'cover',
            };
            this.routeData.bannerImg.push(obj);
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'course','isMobile']),
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      getMesageTitolValue:0,
      courseRelated: [
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
      ],
      showItems: false,
      fileList: [],
      showImgNum: 4,
      currentIndex: 0,
      tags: [],
      myswiper: null,
      number: 0,

      imgList: [
        // { imgUrl: require('/public/img/bg9.jpg') },
        // { imgUrl: require('/public/img/bg3.jpg') },
        // { imgUrl: require('/public/img/bg-pricing.jpg') },
        // { imgUrl: require('/public/img/bdz.png') },
      ], // 因为这是mock过来的，所以这里是空数组
      modalVisible: false,
      navWebGLwindowVisible: false,
      ifc: null,
      isStartDownload: false,
      isFocus: false,
      playerOptions: {},
      isLoading1: false,
      isLoading2: false,
      thisCoure: {},
      treeData: [],
      relatedTreeData: [],
      routeData: {},
      directory: [
        {
          id: 1,
          name: '内容目录',
          isCheck: true,
        },
        {
          id: 2,
          name: '相关课程',
          isCheck: false,
        },
      ],

      refer_list: [
        { value: 'bk', name: '本科' },
        { value: 'gz', name: '高职' },
        { value: 'zz', name: '中职' },
        { value: 'gj', name: '技师学院' },
        { value: 'jx', name: '技校' },
        { value: 'qy', name: '企业' },
      ],
      thumbsSwiper: null,

      tagAll: [
        {
          type: 'PC',
          url: '../../../w10.png',
          name: '打开Window版本',
        },
        {
          type: 'VR',
          url: '../../../vr.png',
          name: '打开VR版本',
        },
        {
          type: 'WebGL',
          url: '../../../webGL.png',
          name: '打开WebGL版本',
        },
        {
          type: 'Android',
          url: '../../../az.png',
          name: '打开安卓版本',
        },
        {
          type: 'ZSpace',
          url: '../../../zspace.png',
          name: '打开ZSpace',
        },
        {
          type: 'KMAX',
          url: '../../../km.png',
          name: '打开KMAX版本',
        },
        {
          type: 'standalone',
          url: '../../../dr.png',
          name: '单机模式',
        },
      ],
      tagAlls: [
        {
          label: 'PC',
          value: 'PC',
        },
        {
          label: 'VR',
          value: 'VR',
        },
        {
          label: 'WebGL',
          value: 'WebGL',
        },
        {
          label: '安卓',
          value: 'Android',
        },
        {
          label: 'ZSpace',
          value: 'ZSpace',
        },
        {
          label: 'KMAX',
          value: 'KMAX',
        },
        {
          label: '单机模式',
          value: 'standalone',
        },
      ],
    };
  },
  methods: {
    getMesageTitol(data){
       this.getMesageTitolValue = data
    },
    handleRemove() {},
    httpRequest(param, type) {
      this.getImgs(param, type);
    },

    async getImgs(param, type = null) {
      await getossUploadToken({})
        .then(result => {
          const creditInfo = result.data;
          const aliOss = new Oss(creditInfo);
          aliOss
            .put(`${type}/${new Date().getTime()}/${param.file.name}`, param.file, {
              headers: {
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then(res => {
              console.log(res);
              let obj = {
                id: this.guid(),
                url: res.url,
              };
              this.routeData.bannerImg.push(obj);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    returnIcon(it) {
      let obj = {
        url: null,
        name: null,
      };
      this.tagAll.forEach(item => {
        if (item.type == it) {
          obj.url = item.url;
          obj.name = item.name;
        }
      });
      return obj;
    },
    async submit() {
      let params = Object.assign({}, this.routeData);
      params.bannerImg.forEach(item => {
        if (item.type && item.type == 'cover') {
          params.bannerImg.splice(0, 1);
        }
      });
      await resetSimulation(params).then(res => {
        if (res.data.acknowledged == true) {
          this.$router.go(-1);
          this.$notify({
            timeout: 1500,
            message: '提交成功！',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.$EventBus.$emit('queryList');
        }
      });
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    deleteImg(item) {
      if (item.type && item.type == 'cover') {
        this.$notify({
          timeout: 1500,
          message: '此张为课程封面，无法删除',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'warning',
        });
        return;
      }

      if (this.routeData.bannerImg.length == 1) {
        this.$notify({
          timeout: 1500,
          message: '至少保留一张图片',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'warning',
        });
        return;
        return;
      }

      if (this.currentIndex == 4) {
        let num = this.currentIndex;
        let thumbnailWrap = document.getElementsByClassName('thumbnailWrap')[0];
        thumbnailWrap.style.transform = `translateX(0%)`;
      }

      this.routeData.bannerImg = this.routeData.bannerImg.filter(items => item.id !== items.id);

      this.currentIndex--;

      console.log(this.currentIndex, 'this.currentIndex');
    },
    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchCurrentX = this.touchStartX;
      this.touchDiffX = 0;
      this.isSwiping = true;
    },
    onTouchMove(event) {
      if (this.isSwiping) {
        this.touchCurrentX = event.touches[0].clientX;
        this.touchDiffX = this.touchCurrentX - this.touchStartX;
      }
    },
    onTouchEnd() {
      this.isSwiping = false;
      if (Math.abs(this.touchDiffX) > 50) {
        // 如果滑动距离超过50px，切换轮播图
        if (this.touchDiffX > 0) {
          this.previous();
        } else {
          this.next();
        }
      }
      this.touchDiffX = 0; // 重置滑动距离差值
    },
    next() {
      if (this.currentIndex < this.routeData.bannerImg.length - 1) {
        this.currentIndex++;
      }

      if (this.currentIndex > 3) {
        let num = this.currentIndex;
        let thumbnailWrap = document.getElementsByClassName('thumbnailWrap')[0];
        thumbnailWrap.style.transform = `translateX(-${(num - 3) * 25}%)`;
      }
    },
    previous() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
      console.log(this.currentIndex);
      if (this.currentIndex <= 3) {
        let num = this.currentIndex;
        let thumbnailWrap = document.getElementsByClassName('thumbnailWrap')[0];
        thumbnailWrap.style.transform = `translateX(0%)`;
      }
    },
    changeSlide(index) {
      this.currentIndex = index;
      console.log(this.routeData.bannerImg);
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getRoute() {
      // courseView //查看    courseEdit 编辑
      let route = null;
      if (this.$route.query && this.$route.query.courseType) {
        route = this.$route.query.courseType;
      }
      return route;
    },
    buttonNext() {
      this.number++;
      if (this.number > 3) {
        this.number = 0;
      }

      // this.number = this.number + 1;
      console.log(this.number);
      //       //这里因为一些原因我找不到它原来问题，但我解决了自己问题了，这里是六张一组缩列图，当第七张的时候缩列图就该切组
      // if (this.number == 6) {
      //      document.getElementById("myNext").click();
      // }
    },
    buttonPrev() {
      this.number--;
      if (this.number < 0) {
        this.number = 3;
      }

      // this.number = this.number - 1;
      console.log(this.number);
    },
    change(index) {
      this.number = index;
      console.log(index, this.number);
      console.log(this.mySwiper.activeIndex);

      // 切换到索引为 2 的幻灯片（即第三张）
      this.mySwiper.slideTo(this.number); // 第二个参数是可选的，表示过渡动画的持续时间
    },

    goBack() {
      // this.$router.push('/simclass')
      this.$router.go(-1);
    },
    //分享
    shareToMicroblog(type) {
      //跳转地址
      let url = encodeURIComponent('http://meta-v4.icubespace.com/');
      let title = encodeURIComponent('元世界.自动化教学设计平台');
      switch (type) {
        case 'weixin':
          break;

        case 'weixinkongjian':
          this.getShareInfo();
          break;

        case 'qq':
          window.open(
            `https://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&source=${url}&desc=${title}&pics=`
          );
          break;

        case 'qqkongjian':
          window.open(
            `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${title}&summary=${title}&site=${url}`
          );
          break;

        case 'weibo':
          window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`);
          break;
      }
    },

    // vue调用微信的自定义分享
    getShareInfo() {},
    isrefer() {
      let str = '';
      this.refer_list.forEach(item => {
        if (this.thisCoure && this.thisCoure.refer) {
          if (item.value == this.thisCoure.refer[0]) {
            str = item.name;
          }
        }
      });
      return str;
    },

    //打开客户端
    async openClientDetail(platform = 'PC') {
      let item = this.routeData;
      // if (!['VR', 'PC'].includes(platform)) return;
      const params = encodeURIComponent(
        JSON.stringify({
          token: localStorage.getItem('token'),
          course: item.courseId ?? item.project.course,
          projectId: item.project ? item.project._id : '',
          version: item.version,
          platform,
          simulationId: item._id,
          runtime: process.env.VUE_APP_RUNTIME,
        })
      );
      if ('WebGL' === platform) {
        window.open(`http://meta.webgl.icubespace.com/WebGL/index.html?json=${params}`, '_blank');
        return;
      }
      this.ifr = document.createElement('iframe');
      this.ifr.src = `MetaSpaceProject://${params}`;
      this.ifr.style.display = 'none';
      document.body.append(this.ifr);
      const appUri = `MetaSpaceProject://${params}`; // 应用程序的地址(注册表应用名称)
      const timeoutDuration = 3000;
      const openAppFailure = () => {
        const url =
          'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/%E8%81%8C%E4%B8%9A%E6%95%99%E8%82%B2%E5%85%83%E4%B8%96%E7%95%8C%E5%AE%89%E8%A3%85%E8%BD%AF%E4%BB%B6V4.7.exe';
        const res = confirm('应用程序未安装,请下载并安装');
        if (res) {
          window.location.href = url; // window.open会被浏览器拦截,使用window.location.href下载exe
        }
      };
      const openAppSuccess = () => {
        console.log('成功打开本地应用程序');
      };

      openUriWithTimeoutHack(appUri, openAppFailure, openAppSuccess, timeoutDuration);

      // const _this = this;
      // this.isFocus = true;

      // const input = document.getElementById('checkIsInstall');
      // input.focus();
      // input.onblur = function() {
      //   this.isFocus = false;
      //   console.log('失去焦点了')
      // }

      // // location.href = `MetaSpaceProject://${params}`;
      // setTimeout(function() {
      //   // document.body.remove(_this.ifc);
      //   if (!_this.isFocus) return;
      //   _this.modalVisible = true;
      // }, 100)
    },

    async openClient() {

    },

    //    transfer3dtiles(appUri) {
    //   openUriWithTimeoutHack(
    //     appUri,
    //     () => {
    //       console.log("未安装");
    //       this.$confirm(
    //         "未安装，下载...",
    //         "提示",
    //         {
    //           confirmButtonText: "下载",
    //           cancelButtonText: "取消",
    //           type: "warning",
    //         }
    //       )
    //         .then(() => {
    //           window.open("下载地址");
    //         })
    //         .catch(() => {
    //           console.log("取消下载");
    //         });
    //     },
    //     () => {
    //       console.log("已安装，自动唤起");
    //     }
    //   );
    // },
    handleDownload() {
      this.modalVisible = false;
      location.href =
        'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/%E8%81%8C%E4%B8%9A%E6%95%99%E8%82%B2%E5%85%83%E4%B8%96%E7%95%8C%E5%AE%89%E8%A3%85%E8%BD%AF%E4%BB%B6V4.7.exe';
    },

    handleBlur() {
      this.isFocus = false;
      // console.log('失去焦点了')
    },

    //跳转页面

    activeTo(item) {
      this.directory.forEach(items => {
        if (items.id == item.id) {
          items.isCheck = true;
        } else {
          items.isCheck = false;
        }
      });
    },
    goBack() {
      // this.$router.push('/simclass')
      this.$router.go(-1);
    },
    async getTree() {
      let params = {
        course: this.routeData.project ? this.routeData.project.course : '',
      };
      queryCourseThree(params).then(res => {
        console.log(res.data, '-------------');
        this.treeData = res.data;
      });
      // this.isLoading1 = true;
      // this.isLoading2 = true;
      // const res = await authCourseList({ currentPage: 1, perPage: 1000 });
      // //查询所有课程
      // if (res.code == "200") {
      //   (this.treeData = []),
      //     (this.relatedTreeData = []),
      //     res.data.rows.forEach((item) => {
      //       if (item["_id"] == this.routeData.project.course) {
      //         this.thisCoure = item;
      //         item.id = item._id;
      //         this.isDeepTree(item, true);
      //       } else {
      //         item.id = item._id;
      //         this.isDeepTree(item, false);
      //       }
      //     });
      // }
    },
    onPlayerPlay(e) {},
    onPlayerPause(e) {},
    onPlayerEnded(e) {},
    onPlayerLoadeddata(e) {},
    onPlayerWaiting(e) {},
    onPlayerPlaying(e) {},
    onPlayerTimeupdate(e) {},
    onPlayerCanplay(e) {},
    onPlayerCanplaythrough(e) {},
    playerReadied(e) {},
    playerStateChanged(e) {},
    fullScreen() {
      var docElm = document.documentElement;
      if (!docElm) return;

      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      }
      //IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    },
    async querydetailList() {
      if (this.$route.query._id) {
        let res = await getdetailList({ _id: this.$route.query._id });

        if (!res.data) return;
        this.routeData = res.data;
        if(this.isMobile.isMobile){
          this.routeData.tag = ['Android']
        }
        this.routeData.bannerImg = this.routeData.bannerImg ?? [];
        // if (this.routeData.project && this.routeData.project.course) {
        //   this.getTree();
        // }
        this.playerOptions = {
          // loop: false, // 导致视频一结束就重新开始。
          // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true, //全屏按钮
          },
          height: '300',
          autoplay: true, //如果true,浏览器准备好时开始回放。
          muted: true, // 默认情况下将会消除任何音频。
          language: 'en', //zh-CN
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          sources: [
            {
              type: 'video/mp4',
              // mp4
              src: 'http://vjs.zencdn.net/v/oceans.mp4',
              // webm
              // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
            },
          ],
          poster: this.routeData.cover, //你的封面地址
        };
        // this.routeData = JSON.parse(this.$route.query.detailId)
      }
    },
  },

  mounted() {
    let _this = this;

    this.querydetailList();

    let content = document.getElementsByClassName('content')[0];
    let header = document.getElementsByClassName('md-toolbar')[0].clientHeight;
    let footer = document.getElementsByClassName('footer')[0].clientHeight;
    let client = document.body.clientHeight - header - footer;
    content.style.cssText = `height:auto; min-height:${client}px;overflow-y:scoll`;
    if (this.$route.query.type && this.$route.query.type == 'home') {
      let timer = setTimeout(() => {
        let dashboardIdMenu = document.getElementById('dashboardIdMenu');
        if (dashboardIdMenu) {
          let dashboardIdMenu = document.getElementById('dashboardIdMenu');
          dashboardIdMenu.style.cssText =
            'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
          clearTimeout(timer);
        }
      }, 400);
    }

    if (this.$route.query.type && this.$route.query.type == 'simclass') {
      let timer = setTimeout(() => {
        let simclassIdMenu = document.getElementById('simclassIdMenu');
        if (simclassIdMenu) {
          let simclassIdMenu = document.getElementById('simclassIdMenu');
          simclassIdMenu.style.cssText =
            'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
          clearTimeout(timer);
        }
      }, 400);
    }
    this.$EventBus.$off('submitform');
    this.$EventBus.$on('submitform', function () {
      _this.submit();
    });
  },

  destroyed() {},
  created() {
    this.getRoute();
    if (this.routeData) {
      console.log(this.routeData);
    }
  },
};
</script>


<style >
@media (max-width: 599px) {
  .footer .container nav ul li > a {
    padding: 5px 10px;
  }
}
</style>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: auto;
  background: #f6f6f6;
  overflow: hidden;
  // background-image: url('../../../assets/img/courseDetail.png');
  // background-repeat: no-repeat;
  // background-size: 100%;
  position: relative;
  // overflow-y: scroll;
  article {
    width: 1260px;
    margin: auto;
    transform: translateY(100px);
    // overflow: hidden;
  }

  .rbox {
    width: 38.5%;
    float: right;
    overflow: hidden;
    .card {
      font: 15px 'Microsoft YaHei', Arial, Helvetica, sans-serif;
      color: #333;
      line-height: 1.5;
      margin: 0;
      padding: 0;
      box-shadow: 0px 1px 0px rgba(255, 255, 255, 0.1), inset 0px 1px 1px rgba(0, 0, 0, 0.7);
      border-radius: 3px;
      background: url('../../../assets/img/courseDetail.png') no-repeat top right
        rgba(42, 42, 42, 1);
      height: 260px;
      overflow: hidden;
      margin-bottom: 20px;
      .card h2 {
        font-size: 22px;
        margin: 10px;
        color: #89919a;
        font-weight: normal;
        padding-bottom: 10px;
      }
      .card p {
        font-size: 12px;
        padding: 0 0 0 20px;
        line-height: 28px;
        text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
        color: #d0d2d4;
        // -webkit-animation: animations2 5s ease-in-out 5s;
        // -moz-animation: animations2 5s ease-in-out 5s;
        // -o-animation: animations2 5s ease-in-out 5s;
        // -ms-animation: animations2 5s ease-in-out 5s;
        // animation: animations2 5s ease-in-out 5s;
      }
    }
  }
}
.thumbnail {
  position: absolute;
  display: inline-block;
  width: 100px; /* 缩略图的宽度 */
  height: 100px; /* 缩略图的高度 */
  cursor: pointer;
  transition: transform 0.3s;
  opacity: 0.5;
  // padding: 4px;
  background: #fff;
}

.thumbnail-active {
  border: 1px solid #333;
  opacity: 1;
}

.thumbnail-image {
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: block;
}

.carousel {
  position: relative;
  max-width: 100%; /* 根据需要调整轮播图的最大宽度 */
  width: 100%;
  margin: auto;
  height: 260px;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  transition: transform 0.6s ease-in-out;
}

.carousel-item {
  min-width: 100%;
  transition: opacity 0.6s ease-in-out;
  height: 260px;
  position: relative;
  overflow: hidden;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  display: block;
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 600px) {
  .carousel-text {
    bottom: 10px;
    font-size: 14px;
  }
  .wrap {
  width: 93%;
  margin: 0 auto 0;
}
.articleStyle{
  width: 100% !important;
}
.wrap article{
    transform: translateY(60px);
  }
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}




.tabsWraps {
  // margin-top: 15px;
  width: 100%;
  overflow: hidden;
  height: auto;
  // margin-top: 20px;
}



/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1300px) {
  article {
    width: 1100px !important;
  }
  // .lbox{
  //   width: 40%;
  // }
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1200px) {
  article {
    width: 1000px !important;
  }
  // .lbox{
  //   width: 40%;
  // }
}

.wrapheader {
  height: 460px;
  z-index: 8;
  // border-bottom: 1px solid #cacaca;
}
@media (max-width: 950px) {
  .wrapheader {
    height: auto !important;
  }
  article {
    width: 96% !important;
  }
  .courseJieSao {
    width: 780px;
  }
  .logWrap .share {
    float: right !important;
  }
}
.back {
  position: absolute;
  left: 20px;
  top: 20px;
  color: #fff;
  cursor: pointer;
}

.articleStyle {
  z-index: 999;
  // position: absolute;
  // left: 0;
  // right: 0;
  // margin: auto;
  // top:68px;
}
</style>